import { render, staticRenderFns } from "./file_button.vue?vue&type=template&id=35e4384e&scoped=true&"
import script from "./file_button.vue?vue&type=script&lang=js&"
export * from "./file_button.vue?vue&type=script&lang=js&"
import style0 from "./file_button.vue?vue&type=style&index=0&id=35e4384e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4384e",
  null
  
)

export default component.exports